// extracted by mini-css-extract-plugin
module.exports = {"unordered-list":"AddAppsToMetasiteConfirmation__unordered-list___ls4fM"};